import React, { useState, createContext, useContext } from 'react';

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [message, setMessage] = useState('');
  const [resolveCallback, setResolveCallback] = useState(null);
  const [visible, setVisible] = useState(false);

  const showConfirm = (text) => {
    return new Promise((resolve) => {
      setMessage(text);
      setVisible(true);
      setResolveCallback(() => resolve);
    });
  };

  const handleYes = () => {
    if (resolveCallback) resolveCallback(true);
    setVisible(false);
    setTimeout(() => {
      setMessage('');
      setResolveCallback(null);
    }, 300); // wait for fade-out
  };

  const handleNo = () => {
    if (resolveCallback) resolveCallback(false);
    setVisible(false);
    setTimeout(() => {
      setMessage('');
      setResolveCallback(null);
    }, 300);
  };

  return (
    <ConfirmContext.Provider value={{ showConfirm }}>
      {children}
      {message && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999,
            opacity: visible ? 1 : 0,
            transition: 'opacity 0.3s ease' // 👈 fade animation
          }}
        >
          <div style={{
            backgroundColor: '#fff', padding: '20px', borderRadius: '10px',
            maxWidth: '300px', width: '80%', textAlign: 'center'
          }}>
            <p style={{ marginBottom: '20px', fontSize: '1rem' }}>{message}</p>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <button onClick={handleYes} style={{ padding: '8px 16px' }}>Yes</button>
              <button onClick={handleNo} style={{ padding: '8px 16px' }}>No</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};
